export function briefingStepElementId(idPrefix: string, stepKey: string): string {
  return `briefing-step-${idPrefix}-${stepKey}`
}

export function scrollToBriefingStep(idPrefix: string, stepKey: string): void {
  document.getElementById(briefingStepElementId(idPrefix, stepKey))?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  })
}
